import { gql } from '@apollo/client';

import { TimeSpentFragment } from '~/@store/timeSpent/timeSpent.queries';

export const CreateTimeSpentFromProjectMutation = gql`
    mutation CreateTimeSpentFromProjectMutation($input: TimeSpentCreateInput!) {
        timeSpentCreate(input: $input) {
            ...TimeSpentFragment
        }
    }

    ${TimeSpentFragment}
`;

export const UpdateTimeSpentFromProjectMutation = gql`
    mutation UpdateTimeSpentFromProjectMutation($id: ID!, $input: TimeSpentUpdateInput!) {
        timeSpentUpdate(id: $id, input: $input) {
            ...TimeSpentFragment
        }
    }

    ${TimeSpentFragment}
`;

export const DeleteTimeSpentFromProjectMutation = gql`
    mutation DeleteTimeSpentFromProjectMutation($id: ID!) {
        timeSpentRemove(id: $id)
    }
`;
